<template>
  <c-card>
    <c-card-body>
      <h2>User logs <span v-if="pages.totalDocs">({{ pages.totalDocs }})</span></h2>
      <template v-if="isLoading">
        <p class="lead">Loading...</p>
      </template>
      <template v-else>
        <template v-if="userLogs.length">
          <table class="table">
            <thead>
            <tr>
              <th class="date">Date</th>
              <th>Action</th>
              <th>Description</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="log in userLogs">
              <td>{{ log.createdAt | dateFormat }}</td>
              <td>{{ log.action }}</td>
              <td>{{ log.description }}</td>
            </tr>
            </tbody>
          </table>
          <paginator
              :page-list="pages.pageList"
              :current-page="Number(pages.currentPage)"
              :num-pages="Number(pages.numPages)"
              @loadPage="get"
          />
        </template>
        <p v-else class="text-h6 is-4">There are no user logs.</p>
      </template>
    </c-card-body>
  </c-card>
</template>

<script>
import { buildEndpoint } from '@/libs/buildEndPoint';
import Paginator from './Paginator';

export default {
  props: {
    user: Object,
  },
  components: {
    Paginator,
  },
  data() {
    return {
      error: null,
      pages: {},
      userLogs: [],
      isLoading: false,
    };
  },

  mounted() {
    this.get();
  },

  methods: {
    get(pageNum = 1) {
      this.isLoading = true;
      this.error = null;
      this.$http
        .get(`${buildEndpoint('user-logs/')}${this.user._id}?page=${pageNum || 1}`)
        .then((response) => {
          this.isLoading = false;
          if (response.data.success) {
            const { data } = response.data;
            this.userLogs = data.docs;
            const pageList = [];
            for (let i = 1; i <= data.pages; i++) {
              if (i > data.page - 5 && i < data.page + 5) {
                pageList.push(i);
              }
            }
            this.pages = {
              numPages: data.pages,
              currentPage: data.page,
              totalDocs: data.total,
              pageList,
            };
          } else {
            this.$store.commit('addErrorMessage', {
              header: 'Error',
              message: 'Error getting log data',
            });
          }
        })
        .catch((error) => {
          this.$store.commit('addErrorMessage', {
            header: 'Error',
            message: error.message,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped="">
table {
  .date {
    width: 200px;
  }
}
</style>
